import { LoginPage } from '@energybox/react-ui-library/dist/components';
import * as v from '@energybox/react-ui-library/dist/utils/validators';

import React from 'react';
import { connect } from 'react-redux';
import { Actions as AppActions } from '../../actions/constants/Actions';
import { login, updateLoginField } from '../../actions/app';
import { ApplicationState } from '../../reducers';
import * as Routes from '../../routes';
import LoginBackground from '../../static/patterns/login_background.jpg';
import { ApiError, renderAPIerror } from '../../utils/apiErrorFeedback';

interface Props {
  email: string;
  password: string;
  apiError: ApiError;
  isPasswordReset: boolean;
  login: () => void;
  onChange: (field: string, value: string) => void;
}

class LoginPageContainer extends React.Component<Props> {
  validateForm = () => {
    const { email, password } = this.props;
    return email !== '' && password !== '' && v.isEmail(email);
  };

  handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.props.login();
  };

  render() {
    const { email, password, apiError, isPasswordReset, onChange } = this.props;

    return (
      <LoginPage
        email={email}
        password={password}
        isPasswordReset={isPasswordReset}
        apiError={renderAPIerror(apiError, AppActions.LOGIN_ERROR)}
        validateForm={this.validateForm}
        handleLogin={this.handleLogin}
        handleChange={onChange}
        forgotPasswordRoute={Routes.FORGOT_PASSWORD}
        backgroundImage={LoginBackground}
      />
    );
  }
}

const mapStateToProps = ({ app }: ApplicationState) => ({
  email: app.loginForm.email,
  password: app.loginForm.password,
  isPasswordReset: app.isPasswordReset,
  apiError: app.apiError,
});

const mapDispatchToProps = {
  onChange: updateLoginField,
  login,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPageContainer);
